{
 "male": [
  "Akmenos",
  "Amnon",
  "Barakas",
  "Damakos",
  "Ekemon",
  "Iados",
  "Kairon",
  "Leucis",
  "Melech",
  "Mordai",
  "Morthos",
  "Pelaios",
  "Skamos",
  "Therai",
  "Malchior",
  "Akmen",
  "Agares",
  "Alastor",
  "Alcimos",
  "Amduse",
  "Andras",
  "Antenor",
  "Arioch",
  "Armaros",
  "Azrik",
  "Balthus",
  "Barbas",
  "Bathin",
  "Belisar",
  "Bezrael",
  "Bileth",
  "Brennus",
  "Caim",
  "Cassiel",
  "Castor",
  "Corvin",
  "Crassus",
  "Cyrian",
  "Dagon",
  "Dantalus",
  "Decarab",
  "Demos",
  "Draxis",
  "Eligos",
  "Elymas",
  "Erebos",
  "Eshmun",
  "Furcas",
  "Gaap",
  "Gamigin",
  "Hadrian",
  "Halphas",
  "Haures",
  "Ipos",
  "Kaelos",
  "Kharon",
  "Lazar",
  "Lerajie",
  "Lycos",
  "Malphas",
  "Marbas",
  "Marchos",
  "Marius",
  "Melchom",
  "Naberius",
  "Nergal",
  "Nisroch",
  "Orobas",
  "Orias",
  "Paimon",
  "Phenex",
  "Purson",
  "Raum",
  "Ronove",
  "Sabnock",
  "Saleos",
  "Samael",
  "Seere",
  "Stolas",
  "Valac",
  "Vapula",
  "Vassago",
  "Vepar",
  "Zagan",
  "Zepar",
  "Ashur",
  "Nabu",
  "Sargon",
  "Nabonid",
  "Belshar",
  "Ubar",
  "Zakir",
  "Erra",
  "Ninurta",
  "Kallias",
  "Theron",
  "Xerxes",
  "Cassius",
  "Varro",
  "Severus",
  "Cato",
  "Nero",
  "Tiberius",
  "Aurelian",
  "Octavian",
  "Lucius",
  "Quintus",
  "Corvus",
  "Sulla",
  "Atticus",
  "Flavian",
  "Septimus",
  "Valerian",
  "Vitus",
  "Remus",
  "Galen",
  "Orestes",
  "Achaios",
  "Kleon",
  "Lykos",
  "Pallas",
  "Phaedon",
  "Tyrian",
  "Erastus",
  "Iason",
  "Kyros",
  "Pyrrhus",
  "Ignatius",
  "Ashkar",
  "Ambrose",
  "Sorrow",
  "Creed",
  "Despair",
  "Glory",
  "Valor",
  "Torment",
  "Temerity",
  "Reverence",
  "Quest",
  "Chant",
  "Nowhere",
  "Weary",
  "Vigil",
  "Penance",
  "Resolve",
  "Fortitude",
  "Wrath",
  "Ruin",
  "Vengeance",
  "Dread",
  "Defiance",
  "Honor",
  "Zeal",
  "Ardor",
  "Pride",
  "Mettle",
  "Courage",
  "Tribute",
  "Verdict",
  "Riddle",
  "Omen",
  "Requiem",
  "Ransom",
  "Pilgrim",
  "Truth",
  "Exile",
  "Cinder",
  "Thorn",
  "Rancor",
  "Dirge",
  "Hymn",
  "Fear",
  "Doubt",
  "Woe",
  "Burden",
  "Remorse",
  "Carrion",
  "Excellence",
  "Ideal",
  "Azrakel",
  "Belzan",
  "Carthos",
  "Draxen",
  "Erimos",
  "Garzan",
  "Haskar",
  "Iskander",
  "Malakar",
  "Mephan",
  "Naxos",
  "Orzhan",
  "Pazrel",
  "Razmus",
  "Sarvos",
  "Tarkan",
  "Uzziel",
  "Xaphan",
  "Yeqon",
  "Zethar",
  "Zoltan",
  "Abraxas",
  "Adramel",
  "Aethon",
  "Amaros",
  "Anzu",
  "Arakiel",
  "Asmodel",
  "Azael",
  "Baraqel",
  "Barzai",
  "Calix",
  "Cassian",
  "Corban",
  "Darius",
  "Dismas",
  "Ebon",
  "Enoch",
  "Ezekiel",
  "Gideon",
  "Hadriel",
  "Ishmel",
  "Jarrah",
  "Kadmos",
  "Kasimir",
  "Korah",
  "Leander",
  "Magnus",
  "Malik",
  "Mattias",
  "Methos",
  "Mirzan",
  "Moros",
  "Nazar",
  "Nikodem",
  "Obed",
  "Phineas",
  "Quillon",
  "Rasim",
  "Sabbas",
  "Sethos",
  "Silas",
  "Tamiel",
  "Thalos",
  "Thanatos",
  "Tobiah",
  "Uriel",
  "Vael",
  "Varek",
  "Vexis",
  "Yorick",
  "Zadkiel",
  "Zebul",
  "Zerah",
  "Azar",
  "Baltazar",
  "Cadmus",
  "Cyrus",
  "Dariel",
  "Elkan",
  "Faustus",
  "Golgoth",
  "Hesperos",
  "Icarus",
  "Jareth",
  "Kael",
  "Lysias",
  "Maelor",
  "Morvran",
  "Nathanael",
  "Ozias",
  "Pharos",
  "Quorin",
  "Reziel",
  "Sirrus",
  "Tarquin",
  "Ulric",
  "Volos",
  "Wystan",
  "Xanthos",
  "Yannic",
  "Zoran",
  "Abaros",
  "Belkor",
  "Cervan",
  "Dusk",
  "Erzan",
  "Fennix",
  "Grigor",
  "Helios",
  "Ilmar",
  "Jaskar",
  "Krios",
  "Levan",
  "Mordecai",
  "Rukhan",
  "Sebastos",
  "Teodric",
  "Urien",
  "Vathek",
  "Belaphon"
 ],
 "female": [
  "Zariel",
  "Lilith",
  "Nyx",
  "Kallista",
  "Orianna",
  "Vesper",
  "Rieta",
  "Hope",
  "Ember",
  "Akta",
  "Anakis",
  "Bryseis",
  "Criella",
  "Damaia",
  "Ea",
  "Lerissa",
  "Makaria",
  "Nemeia",
  "Phelaia",
  "Lilitu",
  "Naamah",
  "Agrat",
  "Eisheth",
  "Mahalath",
  "Lamia",
  "Empusa",
  "Hecate",
  "Erinys",
  "Alecto",
  "Megaera",
  "Tisiphone",
  "Melinoe",
  "Ariadne",
  "Circe",
  "Medea",
  "Kassandra",
  "Xanthe",
  "Ianthe",
  "Phaedra",
  "Calypso",
  "Lethe",
  "Thyra",
  "Ishara",
  "Belili",
  "Ninsun",
  "Shala",
  "Nanshe",
  "Ninlil",
  "Semiramis",
  "Livia",
  "Lucretia",
  "Octavia",
  "Valeria",
  "Cassia",
  "Tullia",
  "Aurelia",
  "Severa",
  "Drusilla",
  "Faustina",
  "Lucilla",
  "Antonia",
  "Cornelia",
  "Fulvia",
  "Junia",
  "Marcella",
  "Portia",
  "Sabina",
  "Domitia",
  "Agrippina",
  "Calpurnia",
  "Galla",
  "Prisca",
  "Lysandra",
  "Eudora",
  "Zenobia",
  "Theodora",
  "Iola",
  "Delphine",
  "Thea",
  "Rhea",
  "Nyssa",
  "Melantha",
  "Dione",
  "Euphemia",
  "Phoebe",
  "Chloris",
  "Daphne",
  "Electra",
  "Antiope",
  "Hermia",
  "Myrrha",
  "Niobe",
  "Pyrrha",
  "Xenia",
  "Mercy",
  "Grace",
  "Faith",
  "Solace",
  "Charity",
  "Temperance",
  "Patience",
  "Prudence",
  "Harmony",
  "Serenity",
  "Constance",
  "Felicity",
  "Verity",
  "Clemency",
  "Lament",
  "Reverie",
  "Longing",
  "Rapture",
  "Elegy",
  "Poetry",
  "Music",
  "Melody",
  "Whisper",
  "Mystery",
  "Destiny",
  "Bliss",
  "Rue",
  "Tempest",
  "Yearning",
  "Ruth",
  "Cadence",
  "Sonnet",
  "Litany",
  "Promise",
  "Devotion",
  "Wonder",
  "Twilight",
  "Midnight",
  "Silence",
  "Secret",
  "Enigma",
  "Folly",
  "Caprice",
  "Fury",
  "Lullaby",
  "Clarity",
  "Liberty",
  "Fortune",
  "Azra",
  "Belphae",
  "Carnelia",
  "Dravia",
  "Esmera",
  "Ishvah",
  "Jezra",
  "Kethra",
  "Lysara",
  "Mavrys",
  "Nazira",
  "Orzha",
  "Pyria",
  "Qadira",
  "Ravenna",
  "Seraxa",
  "Thessa",
  "Uzra",
  "Vashti",
  "Xyla",
  "Yzelda",
  "Zethra",
  "Zerelda",
  "Malphia",
  "Nerissa",
  "Sarai",
  "Shamira",
  "Tamar",
  "Zillah",
  "Adah",
  "Ashara",
  "Belisa",
  "Amarys",
  "Anthea",
  "Astarte",
  "Azuriel",
  "Brisa",
  "Celestra",
  "Corinna",
  "Dahlia",
  "Delia",
  "Desdemona",
  "Drusa",
  "Elara",
  "Eris",
  "Evadne",
  "Fiametta",
  "Gwyndra",
  "Hesper",
  "Ilsabet",
  "Imara",
  "Isadora",
  "Jessamy",
  "Kalliope",
  "Kyra",
  "Lavinia",
  "Liraz",
  "Lucasta",
  "Maelis",
  "Marisol",
  "Meridia",
  "Morwen",
  "Nerys",
  "Nikaia",
  "Ophira",
  "Orsolya",
  "Pandora",
  "Perdita",
  "Raziela",
  "Roxana",
  "Salome",
  "Scylla",
  "Serafine",
  "Sidonie",
  "Sybil",
  "Taliesa",
  "Theda",
  "Vanya",
  "Velora",
  "Veradis",
  "Viola",
  "Xiomara",
  "Yara",
  "Zelia",
  "Zephyra",
  "Zora",
  "Zuleika",
  "Ahlai",
  "Akasha",
  "Ambra",
  "Arethusa",
  "Aziza",
  "Basha",
  "Calixta",
  "Cinna",
  "Damara",
  "Dorcas",
  "Elodie",
  "Emmeline",
  "Eshra",
  "Iolanthe",
  "Jael",
  "Kezia",
  "Kirra",
  "Lucina",
  "Maeve",
  "Mehira",
  "Mireille",
  "Naiara",
  "Nimue",
  "Odessa",
  "Ondine",
  "Petra",
  "Raisa",
  "Reyna",
  "Sabra",
  "Saphira",
  "Sela",
  "Talitha",
  "Thalassa",
  "Tirzah",
  "Ursula",
  "Vashira",
  "Verena",
  "Ximena",
  "Zaida",
  "Zinnia",
  "Anzela",
  "Dariya",
  "Esmeray",
  "Farah",
  "Ghislaine",
  "Hadassah",
  "Inara",
  "Keziah",
  "Lorelei",
  "Melisande",
  "Narcissa",
  "Oriel",
  "Rosalind",
  "Sabelle",
  "Selima",
  "Severine",
  "Thalia",
  "Ulyana",
  "Valentina",
  "Ysolde",
  "Zeruiah",
  "Corisande",
  "Duessa",
  "Evangeline",
  "Ferelith",
  "Galatea",
  "Ilithya",
  "Jacinth",
  "Lisbet",
  "Morgause",
  "Nephele"
 ],
 "family": [
  "Ashveil",
  "Cinderborn",
  "Hollowmere",
  "Nightbrand",
  "Embercoil",
  "Thornheart",
  "Duskwane",
  "Sulphurine",
  "Gloamreach",
  "Vantharis",
  "Ashmantle",
  "Ashgrave",
  "Ashwick",
  "Ashenford",
  "Ashcrown",
  "Ashthorn",
  "Ashfall",
  "Ashwhisper",
  "Cinderfell",
  "Cindermark",
  "Cindervale",
  "Cinderwick",
  "Cindershroud",
  "Cindersong",
  "Emberveil",
  "Emberhand",
  "Embermoor",
  "Emberwake",
  "Embergate",
  "Emberthorn",
  "Emberlace",
  "Brimstone",
  "Brimwick",
  "Brimhollow",
  "Brimmoor",
  "Sulfurmere",
  "Sulfurgate",
  "Smokehollow",
  "Smokeveil",
  "Smokespire",
  "Sootwing",
  "Sootmantle",
  "Charwood",
  "Charcrown",
  "Coalbrand",
  "Coalheart",
  "Flamewither",
  "Pyrebrand",
  "Pyrecaller",
  "Pyresworn",
  "Kindlebrand",
  "Kindlethorn",
  "Scorchmark",
  "Scorchvale",
  "Searbrand",
  "Searwick",
  "Duskmantle",
  "Duskhollow",
  "Duskthorn",
  "Duskweaver",
  "Duskmere",
  "Duskvale",
  "Duskward",
  "Gloamveil",
  "Gloamhart",
  "Gloamspire",
  "Gloamfield",
  "Gloamwick",
  "Nightveil",
  "Nightwhisper",
  "Nightcoil",
  "Nightmere",
  "Nightshroud",
  "Nightspire",
  "Shadowhorn",
  "Shadowmere",
  "Shadowglass",
  "Shadecrown",
  "Shadewick",
  "Shadebloom",
  "Umbercloak",
  "Umberfall",
  "Umbergrave",
  "Umberhollow",
  "Murkwood",
  "Murkwater",
  "Murkspire",
  "Hollowthorn",
  "Hollowcrown",
  "Hollowgate",
  "Hollowsong",
  "Thornmantle",
  "Thornwick",
  "Thornspire",
  "Thorngrave",
  "Thornvane",
  "Bramblethorn",
  "Blightwood",
  "Blighthollow",
  "Gravesend",
  "Graveward",
  "Gravecairn",
  "Ravenmoor",
  "Ravencourt",
  "Ravenmark",
  "Ravenshroud",
  "Crowhollow",
  "Crowmantle",
  "Mothwing",
  "Mothglass",
  "Mothveil",
  "Hexbinder",
  "Hexmoor",
  "Hexwood",
  "Runebrand",
  "Sigilborn",
  "Sigilmark",
  "Brandmoor",
  "Brandvale",
  "Crimsonveil",
  "Crimsonthorn",
  "Scarletwick",
  "Scarlethorn",
  "Vermilion",
  "Garnetcoil",
  "Rubyshade",
  "Onyxheart",
  "Onyxcrown",
  "Obsidianveil",
  "Blackthorn",
  "Blackmantle",
  "Blackwick",
  "Blackvane",
  "Grimwood",
  "Grimhollow",
  "Grimward",
  "Woecrest",
  "Sorrowmere",
  "Ruecastle",
  "Ruewood",
  "Wraithmoor",
  "Wraithveil",
  "Veilborn",
  "Veilwalker",
  "Mournhallow",
  "Mournwick",
  "Mourncrest",
  "Pyrecrest",
  "Ruinvale",
  "Ruinmark",
  "Dreadmoor",
  "Dreadspire",
  "Fellwater",
  "Fellbrand",
  "Witherthorn",
  "Witherglade",
  "Nethercoil",
  "Netherveil",
  "Netherhall",
  "Abyssborn",
  "Hornsworn",
  "Hornwick",
  "Horncastle",
  "Moonbrand",
  "Starfall",
  "Starsorrow",
  "Voidglass",
  "Voidmere",
  "Mirehollow",
  "Fenshadow",
  "Bittersong",
  "Bitterwick",
  "Saltgrave",
  "Wickfall",
  "Candlebane",
  "Lanternfell",
  "Wanecrest",
  "Wanemoor",
  "Eventide",
  "Nightingale",
  "Gloaming",
  "Coilsworn",
  "Malvoisin",
  "Mordecant",
  "Morvaine",
  "Mortmain",
  "Malcrest",
  "Malveil",
  "Malgrave",
  "Corvinus",
  "Corvane",
  "Vespertine",
  "Vesperwood",
  "Noctavian",
  "Nocturne",
  "Tenebris",
  "Umbrafell",
  "Sanguis",
  "Cruorin",
  "Infernis",
  "Ignavar",
  "Ignisfell",
  "Cinerian",
  "Cineris",
  "Favilla",
  "Lucifane",
  "Lumineth",
  "Obscuris",
  "Tenevar",
  "Furvane",
  "Furian",
  "Strigosa",
  "Dolorine",
  "Lacrimar",
  "Valdoria",
  "Valcrest",
  "Vanthorne",
  "Vandemere",
  "Varkessin",
  "Velloris",
  "Velmorra",
  "Verraxis",
  "Vexmoor",
  "Vexhallow",
  "Xanthrel",
  "Zarvenna",
  "Zephriel",
  "Zoravel",
  "Akmenari",
  "Amnonis",
  "Baalvorn",
  "Barakhim",
  "Belzara",
  "Bezraeli",
  "Damakhar",
  "Ekemoran",
  "Iadorris",
  "Kairothis",
  "Leucanth",
  "Melechar",
  "Mordessin",
  "Morthaxis",
  "Pelaithar",
  "Skamorrin",
  "Theraxis",
  "Zarielle",
  "Kallistar",
  "Orianthe",
  "Rietaval",
  "Abrasax",
  "Adramaris",
  "Agrathi",
  "Akkadine",
  "Alastaire",
  "Amduskar",
  "Andravel",
  "Armaroth",
  "Azaroth",
  "Azkavar",
  "Barbatos",
  "Bathinor",
  "Belphegar",
  "Bilethar",
  "Caimoris",
  "Dagonis",
  "Dantalia",
  "Decarabas",
  "Eligorin",
  "Erebothis",
  "Furcasse",
  "Gaapolis",
  "Gamigine",
  "Halpharin",
  "Haurathis",
  "Iposhar",
  "Lerajine",
  "Malpharis",
  "Marbasque",
  "Naberrin",
  "Nergalis",
  "Nisrochar",
  "Orobasque",
  "Paimonde",
  "Phenexis",
  "Pursonne",
  "Raumelle",
  "Ronovin",
  "Sabnockar",
  "Saleosine",
  "Seerath",
  "Sitharis",
  "Stolassi",
  "Valacor",
  "Vapulien",
  "Vassagor",
  "Veparis",
  "Zaganthe",
  "Zepharis",
  "Ashkarai",
  "Azrathine",
  "Belkhoris",
  "Carthexis",
  "Draxonne",
  "Erimossa",
  "Garzanth",
  "Haskarine",
  "Malakarr",
  "Mephistel",
  "Naxorian",
  "Orzhavel",
  "Pazreline",
  "Razmuthis",
  "Sarvossi",
  "Tarkanthe",
  "Uzzielle",
  "Xaphanis",
  "Yeqonis",
  "Zethariel",
  "Anzurath",
  "Barzaith",
  "Cassavane",
  "Corbanthe",
  "Ezekhor",
  "Golgothan",
  "Hesperine",
  "Kadmeris",
  "Korathine",
  "Maelorian",
  "Methosine",
  "Mirzanthe",
  "Morvrandis",
  "Nazarith",
  "Obedrion",
  "Quillonne",
  "Rasimeth",
  "Sethossa",
  "Tamielle",
  "Thalosine",
  "Vaelorne",
  "Varekhis",
  "Vexillor",
  "Zebulon",
  "Zerahine",
  "Lucrevaine",
  "Aurelvane",
  "Drusillan",
  "Valerius",
  "Octavane",
  "Tullianus",
  "Fulvarre",
  "Cornelis",
  "Domitane",
  "Calpurne",
  "Sabinarre",
  "Marcellin",
  "Livianne",
  "Cassiane",
  "Antonis",
  "Faustine",
  "Lucillian",
  "Portivane",
  "Junivar",
  "Agrippane",
  "Galvarre",
  "Priscanth",
  "Ashencourt",
  "Ashbourne",
  "Cinderhall",
  "Cinderlock",
  "Emberlocke",
  "Emberline",
  "Brimvale",
  "Smokewright",
  "Sootmarsh",
  "Charwell",
  "Coalgrave",
  "Pyrewood",
  "Pyrehallow",
  "Kindlewood",
  "Scorchwell",
  "Searmantle",
  "Duskridge",
  "Duskbourne",
  "Gloamwood",
  "Gloamcourt",
  "Nightford",
  "Nightbarrow",
  "Shadowmoor",
  "Shadeford",
  "Umberwell",
  "Umbermoor",
  "Murkhallow",
  "Hollowfen",
  "Hollowmarsh",
  "Thornbury",
  "Thornholt",
  "Brambleveil",
  "Blightmere",
  "Gravemoor",
  "Ravenhurst",
  "Ravenspire",
  "Crowfield",
  "Crowbourne",
  "Mothbarrow",
  "Hexley",
  "Hexmantle",
  "Runewither",
  "Sigilthorn",
  "Brandhallow",
  "Crimsonfell",
  "Scarletmoor",
  "Garnetwick",
  "Onyxwood",
  "Obsidiane",
  "Blackfen",
  "Blackbarrow",
  "Grimcairn",
  "Woehallow",
  "Sorrowcrest",
  "Ruemoor",
  "Wraithcourt",
  "Veilmoor",
  "Mournfield",
  "Ruinhallow",
  "Dreadwick",
  "Fellmoor",
  "Witherwick",
  "Netherwood",
  "Hornmantle",
  "Hornbarrow",
  "Moonwither",
  "Starshroud",
  "Voidcrest",
  "Mirewick",
  "Gallthorn",
  "Bittermere",
  "Saltmarsh",
  "Candlewither",
  "Lanternwick",
  "Waneford",
  "Morvessin",
  "Malkethar",
  "Corvalis",
  "Vespermoor",
  "Noctaris",
  "Tenebrine",
  "Ignavoss",
  "Cinerath",
  "Obscuran",
  "Furvellis",
  "Lacrimosa",
  "Dolorian",
  "Valvessin",
  "Vanthrax",
  "Varkoth",
  "Velkhoris",
  "Verrimaine",
  "Xanthessa",
  "Zarvoss",
  "Ashmodar",
  "Baelvaris",
  "Carcaroth",
  "Dravessin",
  "Esmordai",
  "Hadrazel",
  "Iskhandra",
  "Jezrathi",
  "Kazrimor",
  "Lazaroth",
  "Maelvoss",
  "Narzhael",
  "Orzhevan",
  "Pazurai",
  "Qadrathis",
  "Razaveth",
  "Szelmara",
  "Thalmorra",
  "Uzravel",
  "Vashkoris",
  "Xerevaine",
  "Yzkarion",
  "Zathrimor",
  "Akhenvar",
  "Belshazzar",
  "Corrovane",
  "Dovrathis",
  "Eshkarim",
  "Fenrathis",
  "Ghazarin",
  "Haldrevane",
  "Imbrassi",
  "Kethravel",
  "Lysmordai",
  "Mavrothis",
  "Nemorai",
  "Ombravel",
  "Perditane",
  "Quorvassi",
  "Rhazaveil",
  "Selvarith"
 ]
}